<template>
  <div class="profile-menu" v-closable="hideMenu" @keyup.esc="hideMenu">
    <button class="profile-menu__button" @click="toggleMenu">
      <BaseAvatar :name="name" :imageUrl="imageUrl" :color="color" />

      <div class="profile-menu__identification">
        <span class="profile-menu__name">
          {{ name }}
        </span>
        <span class="profile-menu__email">{{ email }}</span>
      </div>

      <BaseIcon name="chevron-down" />
    </button>
    <transition name="dropdown-basic">
      <ul class="profile-menu__list" v-show="isMenuVisible">
        <li class="profile-menu__item--preferences">
          <button class="profile-menu__action" @click="preferencesClick">
            <BaseIcon name="settings" />
            {{ $t('menu.settings') }}
          </button>
        </li>
        <li class="profile-menu__item--logout">
          <button class="profile-menu__action" @click="logoutClick">
            <BaseIcon name="log-out" />
            {{ $t('login.log-out') }}
          </button>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import BaseAvatar from '@/components/base/BaseAvatar';
import BaseIcon from '@/components/base/BaseIcon';
import { paths } from '@/util/paths';
import { Beacon } from '@/plugins/beacon';

import { mapActions } from 'vuex';

export default {
  name: 'NavigationBarProfile',
  components: {
    BaseAvatar,
    BaseIcon,
  },
  data() {
    return {
      isMenuVisible: false,
    };
  },
  props: {
    name: {
      type: String,
      default: 'Mon compte',
    },
    email: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#fcdbd9',
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),
    logoutClick() {
      Beacon.reset();
      this.logout().then(() => {
        this.$track.signOut();
        // After logout, redirect to login page and refresh the page to reset the store
        this.$router.push(paths.login).then(() => this.$router.go());
      });
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    hideMenu() {
      this.isMenuVisible = false;
    },
    preferencesClick() {
      this.$router.push(paths.adminUserProfile);
      this.hideMenu();
    },
  },
};
</script>

<style lang="scss">
.profile-menu {
  padding: 12px 32px;
  position: relative;
  max-height: 96px;

  &__identification {
    padding-left: 12px;
    display: block;
    text-align: left;
  }

  &__email {
    font-size: $font-size-xsmall;
    display: block;
  }

  &__button {
    align-items: center;
    border: none;
    background: none;
    cursor: pointer;
    display: flex;
    font-family: $font-family-raleway;
    outline: none;
    padding: 0;
    transition: color 200ms ease;

    &:hover,
    &:active {
      color: $color-accent;

      .feather {
        color: $color-accent;
      }
    }

    &:focus {
      box-shadow: $shadow-focus-outline;
    }

    .feather {
      color: $color-border;
      height: 24px;
      width: 24px;
      margin-left: 8px;
      transition: color 200ms ease;
    }
  }

  &__list {
    background-color: $color-white;
    border-radius: $border-radius-small;
    box-shadow: $shadow-center;
    list-style: none;
    padding: 24px 32px;
    position: absolute;
    margin: 0;
    right: 32px;
    top: 120%;
    width: 270px;
  }

  &__item {
    list-style: none;
    padding: 5px 0px;
    margin: 0;

    + .profile-menu__item {
      margin-top: 8px;
    }

    &--preferences {
      padding-bottom: 10px;
    }

    &--logout {
      border-top: $color-border 1px solid;
      padding-top: 10px;
    }
  }

  &__action {
    align-items: center;
    border: none;
    background: none;
    color: $color-normal;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    padding: 8px 0;
    outline: none;
    transition: color 200ms ease;
    text-align: left;
    width: 100%;
    text-decoration: none;

    .feather {
      color: $color-neutral;
      height: 20px;
      margin-right: 8px;
      transition: color 200ms ease;
      width: 20px;
    }

    &:hover,
    &:active {
      color: $color-accent;

      .feather {
        color: $color-accent;
      }
    }

    &:focus {
      box-shadow: $shadow-focus-outline;
    }
  }

  @media screen and (max-width: 1080px) {
    &__identification {
      display: none;
    }
  }
}
</style>
